import React, { useContext, useState, useEffect } from "react";
import { Table, Button, Form, Pagination, Spinner, Col, Row } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';
import axios from "axios";
import * as CONST from "../../includes/Constant";
import { Link } from "react-router-dom";
import Loading from 'react-fullscreen-loading';
import { AuthContext } from '../../context/AuthContext';
import InvoicePayments from "./InvoicePayments";
import InvoiceHistory from "./InvoiceHistory";
import BootstrapTable from "react-bootstrap-table-next";
import Select from 'react-select';
import { toast } from "react-toastify";
import DatePicker from "react-datepicker";
import useAuthInfo from "../../../hooks/IsAdmin";
import { S_CURRENT_FINACIAL_MONTH, S_FORMAT_CURRENCY_AND_AMOUNT, S_FORMAT_INR_CURRENCY_AND_AMOUNT, S_GET_CURRENCY_SYMBOL, S_INR_CURRENCY_SYMBOL, SD_CAPITALIZE, SD_FY_MONTHS, SD_INVOICE_STATUS, SD_PROJECT_TYPE } from "../../includes/staticData";
import { setGlobalModal } from "../modal/GlobalModal";
import "../../../assets/css/admin.css";
import '../../../invoice.css';
import ViewInvoice from "../modal/invoice/ViewInvoice";
import ViewClient from "../modal/client/ViewClient";
import ViewProjects from "../modal/project/ViewProjects";
import UpdateInvoiceProject from "../modal/project/UpdateInvoiceProject";
import ReactTooltip from "react-tooltip";

const Invoice = () => {
  const [arrProjects, setArrProjects] = useState([]);

  const { isAdmin, eDepartmentId } = useAuthInfo();
  const [authUserData, setAuthUserData] = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordsPerPage, setRecordsPerPage] = useState(50);
  const [sortColumn, setSortColumn] = useState("inv.id");
  const [sortOrder, setSortOrder] = useState("desc");
  const [loading, setLoading] = useState(false);
  const [paymentsInvoiceId, setPaymentsInvoiceId] = useState();
  const [invoiceStatus, setInvoiceStatus] = useState();
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [showInvoiceHistoryModal, setShowInvoiceHistoryModal] = useState(false);
  const [currentUser, setCurrentUser] = useState(authUserData ? authUserData[0].user_id : 1);
  /* SEARCH VARIABLES */
  const [financialYears, setFinancialYears] = useState([]);
  const [currentFinancialYears, setCurrentFinancialYears] = useState([]);
  const [status, setStatus] = useState('pending');
  const [selectedYear, setSelectedYear] = useState(null);
  const [invoiceDate, setInvoiceDate] = useState(null);
  const [searchParams, setSearchParams] = useState({});
  const [clients, setClients] = useState([]);
  const [client, setClient] = useState("");
  const [departmentData, setDepartmentData] = useState([]);
  const [departments, setDepartments] = useState(null);
  const [userDepartment, setUserDepartment] = useState("");
  const [invoiceId, setInvoiceId] = useState("");
  const [invoiceCurrency, setInvoiceCurrency] = useState("");
  const [project, setProject] = useState([]);
  const [projectType, setProjectType] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(null);
  useEffect(() => {
    if (!isAdmin && departmentData.length > 0) {
      const matchedDept = departmentData.find((d) => d.value === eDepartmentId);

      if (matchedDept) {
        setUserDepartment(matchedDept);
        setDepartments(matchedDept);
        setSearchParams((prev) => ({
          ...prev,
          department_id: eDepartmentId
        }));

        fetchClientData(eDepartmentId);
      }
    }
  }, [isAdmin, departmentData]);

  useEffect(() => {

    if (searchParams.financialYear) {
      fetchData();
    }
  }, [currentPage, recordsPerPage, sortColumn, sortOrder, searchParams]);

  useEffect(() => {
    const generateFinancialYears = () => {
      const startYear = 2023; // Start from 2024-2025
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;

      let financialYearsList = [];
      let endYear = currentMonth >= 4 ? currentYear : currentYear - 1;

      // Loop from latest year to startYear to make latest year appear first
      for (let year = endYear; year >= startYear; year--) {
        financialYearsList.push({
          value: `${year}-${year + 1}`,
          label: `${year}-${year + 1}`,
        });
      }

      setFinancialYears(financialYearsList);

      // Set the current financial year as default selection
      const currentFinancialYear = `${endYear}-${endYear + 1}`;
      /* setCurrentFinancialYears({
        currentFinancialYear,

      }); */
      const selectedFY = financialYearsList.find(year => year.value === currentFinancialYear);
      setSearchParams((prev) => ({
        ...prev,
        financialYear: currentFinancialYear
      }));
      setSelectedYear(selectedFY);
      setCurrentFinancialYears(selectedFY);
      setSelectedMonth();
      setCurrentMonth(S_CURRENT_FINACIAL_MONTH());
    };

    fetchDepartmentData();
    generateFinancialYears();
    fetchAllProjects();
  }, []);
  useEffect(() => {
    if (client) {
      fetchClientProjects(client.value);
    }
  }, [client]);
  const fetchDepartmentData = async () => {
    try {
      const departmentResponse = await axios.get(CONST.GET_DEPARTMENT_LIST);
      if (departmentResponse.data.status === 'success') {
        setDepartmentData(departmentResponse.data.data.map(department => ({ value: department.id, label: department.name })));
      }
    } catch (error) {
      toast.error('Error:', error);
    }
  };

  const fetchClientData = async (departmentId) => {
    setLoading(true);
    try {
      const clientsResponse = await axios.get(CONST.GET_ALL_CLIENT, {
        params: departmentId ? { department_id: departmentId } : {},
      });
      //const clientsResponse = await axios.get(CONST.GET_ALL_CLIENT);
      if (clientsResponse.data.status === 'success') {
        setClients(clientsResponse.data.data.map(client => ({
          value: client.id,
          label: client.name,
        })));
      }
    } catch (error) {
      toast.error('Error:', error);
    }
    setLoading(false);
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(CONST.GET_INVOICE_LIST, {
        params: {
          page: currentPage,
          per_page: recordsPerPage,
          sort_by: sortColumn,
          sort_order: sortOrder,
          client_id: searchParams.client,
          status: searchParams.status,
          invoice_date: searchParams.invoice_date,
          financial_year: searchParams.financialYear,
          department_id: searchParams.department_id,
          invoice_id: searchParams.invoice_id,
          project_id: searchParams.project_id,
          project_type: searchParams.project_type,
          month: selectedMonth?.value,
        }
      });
      if (response.data) {
        setData(response.data.data);
        setTotalRecords(response.data.total);
      } else {
        setData([]);
        setTotalRecords(0);
      }
    } catch (error) {

      setData([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };
  /* GET CLIENT PROJECT */
  const fetchClientProjects = async (clientId) => {
    try {
      const response = await axios.post(CONST.GET_CLIENT_PROJECTS, { cid: clientId });
      if (response.data.status === 'success') {
        setArrProjects(response.data.data.map(project => ({ value: project.id, label: project.name })));
      }
    } catch (error) {
      toast.error('Error fetching projects:', error);

    }
  };
  /* GFET ALL PROJECTS */
  const fetchAllProjects = async () => {
    try {
      const response = await axios.get(CONST.GET_PROJECT_LIST);
      if (response.data) {
        setArrProjects(response.data.data.map(project => ({ value: project.project_id, label: project.project_name })));
      }
    } catch (error) {
      toast.error('Error fetching projects:', error);

    }
  };
  const getCurrencySymbol = (currencyCode) => {
    return (0).toLocaleString("en", { style: "currency", currency: currencyCode }).replace(/\d|,|\.|\s/g, '');
  };
  const formatINRCurrency = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
    }).format(amount);
  };

  const invoiceStatusOptions = SD_INVOICE_STATUS.map((invoiceStatus) => ({
    label: invoiceStatus.name,
    value: invoiceStatus.code,
  }));

  /* TABLE FUNCTIONS  */
  const actionFormatter = (cell, row) => {
    return (
      <>

        {
          (row && (row.status !== 2)) ? (
            <>
              <Link to={CONST.ADMIN_PRE + 'invoice/edit/' + row.invoice_id} className="action"
                data-tooltip-id="tooltip"
                data-tooltip-content="Edit Invoice"
              >
                <i className='bx bx-pencil'></i>
              </Link>
            </>
          ) : ""
        }
        {
          row && (row.status !== 1 && row.status !== 4) && (
            <>
              <Link to="#" className="action" onClick={() => handlePayment(row.invoice_id, row.status, row)}
                data-tooltip-id="tooltip"
                data-tooltip-content="Invoice Payment"
              >
                <i className='bx bx-wallet'></i>
              </Link>
            </>
          )
        }
        {
          (row.pdf_link && row.pdf_link && row.status !== 1) ?
            <>
              <Link to="#" className="action" onClick={() => handleView(row.pdf_link)}
                data-tooltip-id="tooltip"
                data-tooltip-content="View Invoice"
              >
                <i className='bx bx-show'></i>
              </Link>
              <Link to="#" className="action" onClick={() => handleDownload(row.pdf_link)}
                data-tooltip-id="tooltip"
                data-tooltip-content="Invoice Download">
                <i className='bx bx-download' ></i>
              </Link>
            </> : ""
        }
        <Link
          to={CONST.ADMIN_PRE + `invoice/add?clone=${row.invoice_id}`}
          className="action"

          data-tooltip-id="tooltip"
          data-tooltip-content="Copy Invoice">
          <i class='bx bx-copy'></i>
        </Link>
        <Link to="#" className="action" onClick={() => handleInvoiceHistory(row.invoice_id)}
          data-tooltip-id="tooltip"
          data-tooltip-content="Invoice History"
        >
          <i className='bx bx-history'></i>
        </Link>

      </>
    );
  };
  const columns = [
    {
      dataField: "invoice_number",
      text: "Invoice #",
      sortable: true,
      width: "100px",
      textAlign: "left",
      onSort: () => handleSort("invoice_number"),
      formatter: (cell, row) => {
        const invoice_number = row.invoice_number || '';
        const client_name = row.client?.name || "N/A";
        const invoice_id = row.invoice_id || null;
        return (
          <>
            <Link to="#" className="action"
              data-tooltip-id="tooltip"
              data-tooltip-content="View Invoice"
              onClick={() =>
                setGlobalModal(
                  ViewInvoice,
                  {
                    invoice_id: invoice_id,
                  },
                  {  // Modal Props
                    size: "xl",
                    title: "#" + invoice_number + " - " + client_name
                  }
                )
              }
            >
              {invoice_number}
            </Link >
          </>
        );
      }

    },
    {
      dataField: "client.name",
      text: "Client Info",
      sortable: true,
      width: "150px",
      textAlign: "left",
      onSort: () => handleSort("client.name"),
      formatter: (cell, row) => {
        const client_name = row.client?.name || "N/A";
        const client_email = row.client?.email || "N/A";
        const client_company_name = row.client?.company_name || "N/A";
        const project_name = row?.project_name || "";
        const invoice_id = row.invoice_id || null;
        const invoice_number = row.invoice_number || '';
        return (
          <>
            <Link to="#" className="action"
              data-tooltip-id="tooltip"
              data-tooltip-content="View Client"
              onClick={() =>
                setGlobalModal(
                  ViewClient,
                  {
                    client_id: row.client_id,
                  },
                  {  // Modal Props
                    size: "lg",
                    title: "View Client " + client_name
                  }
                )
              }
            >
              {client_name}
            </Link > <br />
            <Link to="#" className="action"
              data-tooltip-id="tooltip"
              data-tooltip-content="View Project"
              onClick={() =>
                setGlobalModal(
                  ViewProjects,
                  {
                    project_id: row.project_id,
                  },
                  {  // Modal Props
                    size: "md",
                    title: "Project: " + project_name
                  }
                )
              }
            >
              <span class="small-badge">{SD_CAPITALIZE(project_name)}</span>
            </Link >
            <Link to="#" className="pl-1"
              data-tooltip-id="tooltip"
              data-tooltip-content="Update Project"
              onClick={() =>
                setGlobalModal(
                  UpdateInvoiceProject,
                  {
                    client_id: row.client_id,
                    project_id: row.project_id,
                    invoice_id: invoice_id,
                    invoice_data: row,
                    onClose: fetchData
                  },
                  {  // Modal Props
                    size: "md",
                    title: "Update Invoice: " + invoice_number
                  }
                )
              }
            ><i class='small-badge bx bxs-pencil'></i>
            </Link>

          </>
        );
      }
    },
    {
      dataField: "total_amount",
      text: "Amount",
      sortable: true,
      textAlign: "right",
      onSort: () => handleSort("total_amount"),
      formatter: (cell, row) => {
        const total_gross_payment = row.total_gross_payment;
        const total_gst_amount = row.total_gst_amount;
        const total_amount = row.total_amount;
        if (row.client?.country === "IN") {
          return (
            <>
              {S_FORMAT_INR_CURRENCY_AND_AMOUNT(total_gross_payment)}
              {/* <div><strong>GST:</strong> {S_FORMAT_INR_CURRENCY_AND_AMOUNT(total_gst_amount)}</div> */}
              {/* <div><strong>Total:</strong>  {S_FORMAT_INR_CURRENCY_AND_AMOUNT(total_amount)}</div> */}
            </>
          );
        } else {
          return <>{S_FORMAT_CURRENCY_AND_AMOUNT(row.currency || "INR", total_amount || 0)} </>;
        }
      }
    },
    {
      dataField: "total_gst_amount",
      text: `GST (${S_GET_CURRENCY_SYMBOL("INR")})`,
      sortable: true,
      textAlign: "right",
      onSort: () => handleSort("total_amount"),
      formatter: (cell, row) => {
        const total_gst_amount = row.total_gst_amount;
        return (
          <>{S_FORMAT_INR_CURRENCY_AND_AMOUNT(total_gst_amount)}</>
        )
      }
    },
    {
      dataField: "total_amount_inr",
      text: `Amount (${S_GET_CURRENCY_SYMBOL("INR")})`,
      sortable: true,
      textAlign: "right",
      onSort: () => handleSort("total_amount_inr"),
      formatter: (cell, row) => {
        const exchange_rate = row.exchange_rate || 0;
        const inr_payment = row.total_amount_inr || 0;

        if (row.client?.country === "IN") {
          return (
            <>
              {S_FORMAT_INR_CURRENCY_AND_AMOUNT(inr_payment)}
            </>
          );
        } else {
          return (
            <>
              {S_FORMAT_INR_CURRENCY_AND_AMOUNT(inr_payment)}
              <br />
              <span class="badge bg-secondary">Ex rate: ({exchange_rate})</span>
            </>
          );
        }
      }
    }
    ,
    /* {
      dataField: "platform_fee",
      text: "Fee",
      sortable: false,
      formatter: (cell, row) => {
        const platform_fee = S_FORMAT_INR_CURRENCY_AND_AMOUNT(row.platform_fee ?? 0);
        return (
          <>
            {platform_fee}
          </>
        );
      }
    }, */
    {
      dataField: "total_payments",
      text: "Received",
      sortable: true,
      onSort: () => handleSort("total_payments"),
      formatter: (cell, row) => {
        console.log(row.platform_fee);
        const totalPayments = row.total_payments ?? 0;
        const formattedAmount = S_FORMAT_INR_CURRENCY_AND_AMOUNT(totalPayments);
        const isHighlighted = parseInt(row.status) === 5 || row.is_considered === true;
        const platform_fees = S_FORMAT_INR_CURRENCY_AND_AMOUNT(row.platform_fee ?? 0);
        const actual_amount =
          (parseFloat(row.total_payments) || 0) + (parseFloat(row.platform_fee) || 0);

        return (
          <div style={{ textAlign: "right" }}>
            {isHighlighted ? <strong>{formattedAmount}</strong> : formattedAmount}
            <br />
            <span class="small-badge">fees: ({platform_fees})</span><br />
            <span class="badge bg-primary" >({S_FORMAT_INR_CURRENCY_AND_AMOUNT(actual_amount)})</span>

          </div>
        );
      }
    }

    ,
    {
      dataField: "user_name",
      text: "Created By",
      sortable: true,
      onSort: () => handleSort("user_name"),
    },
    {
      dataField: "invoice_date",
      text: "Invoice Date",
      sortable: true,
      onSort: () => handleSort("invoice_date"),
      formatter: (cell) => {
        if (!cell) return "";
        const date = new Date(cell);
        return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
      }
    },
    {
      dataField: "status",
      text: "Status",
      sortable: true,
      onSort: () => handleSort("status"),
      formatter: (cell) => {
        const statusItem = SD_INVOICE_STATUS.find(item => item.code === String(cell));
        const statusText = statusItem ? statusItem.name : "Unknown";
        const statusClass = statusItem ? statusItem.color : "bg-secondary";

        return <span className={`badge ${statusClass}`}>{statusText}</span>;
      }
    },
    {
      dataField: "actions",
      text: "Actions",
      sortable: false,
      formatter: actionFormatter,
    },


  ];
  /* HANDLES */
  const handleYearChange = (selectedOption) => {
    setSelectedYear(selectedOption);

  };

  const handleInvoiceChange = (selectedOption) => {

    setInvoiceId(selectedOption);
  };

  const handleSearch = () => {

    setSearchParams({
      client: client ? client.value : "",
      status: status ? status.value : "",
      invoice_date: invoiceDate
        ? invoiceDate.toLocaleDateString('en-CA') // 'YYYY-MM-DD' format
        : "",
      financialYear: selectedYear ? selectedYear.value : "",
      department_id: departments ? departments.value : "",
      invoice_id: invoiceId,
      project_id: project ? project.value : "",
      project_type: projectType ? projectType.value : "",
      month: selectedMonth ? selectedMonth.value : "",
    });
    /* fetchData(); */
  };
  const handleReset = () => {
    setLoading(true);
    setProjectType(null);
    setClient(null);
    setStatus(null);
    setInvoiceDate(null);
    setSelectedYear(currentFinancialYears);
    setCurrentPage(1);
    setInvoiceId("");
    setProject("");
    setSelectedMonth("");
    if (!isAdmin) {
      setSearchParams({
        client: "",
        status: "",
        invoice_date: "",
        financialYear: currentFinancialYears ? currentFinancialYears.value : "",
        department_id: departments ? departments.value : "",
        project_id: "",
        project_type: "",
        month: "",
      });
    } else {
      setDepartments(null);
      setSearchParams({
        client: "",
        status: "",
        invoice_date: "",
        financialYear: currentFinancialYears ? currentFinancialYears.value : "",
        department_id: "",
        project_id: "",
        project_type: "",
        month: "",
      });
    }


    setLoading(false);
  };

  const handleClientChange = (selectedOption) => {
    setClient(selectedOption);
  };
  const handleProjectChange = (selectedOption) => {
    console.log(selectedOption)
    setProject(selectedOption);
  };
  const handleDepartmentChange = (selectedOption) => {
    setDepartments(selectedOption);

    fetchClientData(selectedOption?.value)
  };

  const handleStatusChange = (selectedOption) => {
    setStatus(selectedOption);
  };

  const handleDateChange = (date) => {
    setInvoiceDate(date);
  };
  const handleSort = (column) => {
    const order = sortColumn === column && sortOrder === "asc" ? "desc" : "asc";
    setSortColumn(column);
    setSortOrder(order);
  };
  /* PDF VIEW & DOWNLOAD */
  const handleView = (pdf) => {
    setLoading(true);
    const iLink = CONST.PDF_LINK + pdf;
    window.open(iLink, "_blank");
    setLoading(false);
  };

  const handleDownload = (pdf) => {
    setLoading(true);
    const iLink = CONST.PDF_LINK + pdf;
    const link = document.createElement("a");
    link.href = iLink;

    // Extract filename from URL
    const fileName = iLink.split("/").pop();

    // using Java Script method to get PDF file
    fetch(iLink).then((response) => {
      response.blob().then((blob) => {

        // Creating new object of PDF file
        const fileURL =
          window.URL.createObjectURL(blob);

        // Setting various property values
        let alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = fileName;
        alink.click();

      });
    });
    setLoading(false);
  };
  /* Modal */
  const handlePayment = (invoice_id, invoice_status, row) => {
    setPaymentsInvoiceId(invoice_id);
    setInvoiceStatus(invoice_status);
    setSelectedInvoice(row);
    setInvoiceCurrency(row.currency);
    setShowPaymentModal(true);
  };
  const handleInvoiceHistory = (invoice_id) => {

    setPaymentsInvoiceId(invoice_id);
    setShowInvoiceHistoryModal(true);
  };
  const handlePaymentClose = () => {
    setShowPaymentModal(false);
    setSelectedInvoice("");
    setInvoiceCurrency("");
    fetchData();
  };
  const handleInvoiceHistoryModalClose = () => {
    setShowInvoiceHistoryModal(false);

  };
  const handlePageChange = (e) => {
    setRecordsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  /* HANDLE PROJECT TYPE */
  const projectTypeOptions = SD_PROJECT_TYPE.map((projectType) => ({
    label: projectType.name,
    value: projectType.code,
  }));
  const handleProjectType = (selectedOption) => {
    console.log(selectedOption)
    setProjectType(selectedOption);
  };
  /* Month */
  const handleMonthChange = (selectedOption) => {
    setSelectedMonth(selectedOption);
  };
  return (
    <>
      <Loading loading={loading} background="rgba(0, 0, 0, 0.5)" loaderColor="#fff" />
      <div className="container-fluid p-0">
        <div className="row mb-5">
          <Col md={6} sm={6}>
            <h1 className="h3 mb-2">Manage <strong>Invoice</strong></h1>
          </Col>
          <Col md={6} sm={6} className="text-right">
            <Link className="btn btn-secondary" to={CONST.ADMIN_PRE + 'invoice/add'}><i className='bx bx-plus-circle'></i>Create Invoice</Link>
            <Link className="ml-1 btn btn-primary" to={CONST.ADMIN_PRE + 'report/invoice-payment'}><i className='bx bxs-report'></i>View Report</Link>
          </Col>

        </div>
        <Row className="mb-2">
          {/* Financial Year Dropdown */}
          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <Select
              options={financialYears}
              placeholder="Financial Year..."
              onChange={handleYearChange}
              value={selectedYear}
            />
          </Col>
          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <Select
              options={SD_FY_MONTHS}
              placeholder="Select Month"
              onChange={handleMonthChange}
              value={selectedMonth}
            />
          </Col>
          {
            (isAdmin) ? (
              <>
                <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
                  <Select
                    options={departmentData}
                    placeholder="Department..."
                    onChange={handleDepartmentChange}
                    value={departments}
                  />
                </Col>
              </>
            ) : ""
          }
          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <input
              type="text"
              className="form-control"
              name="invoice_number"
              onChange={(e) => setInvoiceId(e.target.value)}
              placeholder="Invoice Number"
              value={invoiceId}
            />
          </Col>
          {/* Date Picker (Fixed Placeholder) */}
          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <DatePicker
              dateFormat="dd/MM/yyyy"
              selected={invoiceDate}
              onChange={handleDateChange}
              className="form-control"
              placeholderText="Invoice Date" // Corrected placeholder usage
            />
          </Col>
          {/* Client Dropdown */}
          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <Select
              options={clients}
              placeholder="Client.."
              onChange={handleClientChange}
              value={client}
            />
          </Col>
          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <Select
              placeholder="Project..."
              options={arrProjects}
              onChange={handleProjectChange}
              value={project}
            />
          </Col>
          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <Select
              options={projectTypeOptions}
              placeholder="Type..."
              onChange={handleProjectType}
              value={projectType}
            />
          </Col>



          <Col xs={12} sm={3} md={3} lg={3} xl={2} className="mb-1">
            <Select
              options={invoiceStatusOptions}
              placeholder="Status..."
              onChange={handleStatusChange}
              value={status}
            />
          </Col>
          <Col className="text-right mb-1 mt-2" >
            <Button variant="primary" onClick={handleSearch}>
              <i className='bx bx-search-alt'></i> {" "} Search
            </Button>
            <Button
              variant="secondary"
              onClick={handleReset}
              className="ml-1"
              title="Reset"
            >
              <i className='bx bx-x'></i> {" "} Reset
            </Button>
          </Col>
        </Row>

        <div className="row mb-1">

          <div className="card flex-fill pt-3 pb-2">
            <div className="col-12">
              Showing total {totalRecords}
              <select className="m-2" onChange={handlePageChange} value={recordsPerPage}>
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select> records
            </div>

            <Table striped bordered hover responsive className="report-table">
              <thead>
                <tr>
                  {columns.map((col) => (
                    <th
                      key={col.dataField}
                      onClick={() => col.sortable && handleSort(col.dataField)}
                      style={{ cursor: col.sortable ? "pointer" : "default" }}
                    >
                      {col.text}
                      {col.sortable && (sortColumn === col.dataField ? (sortOrder === "asc" ? " ▲" : " ▼") : "")}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {
                  data && data.length > 0 ?
                    (data.map((item, index) => (
                      <tr
                        key={index}
                        className={item.status === 5 ? "bold-row" : ""}
                        data-status={item.status}
                      >
                        {columns.map((col) => (
                          <td
                            key={col.dataField}
                            style={{ width: col.width, textAlign: col.textAlign ? col.textAlign : "center" }}

                          >
                            {col.formatter ? col.formatter(item[col.dataField], item) : item[col.dataField]}
                          </td>
                        ))}
                      </tr>
                    ))
                    ) : (
                      <tr>
                        <td colSpan={columns.length} className="text-center">
                          No records found.
                        </td>
                      </tr>
                    )
                }

              </tbody>
            </Table>
            <div className="row">
              <div className="col-md-4">
                Showing total {totalRecords}
                <select className="m-2" onChange={handlePageChange} value={recordsPerPage}>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select> records
              </div>
              <div className="col-md-8 text-right">
                <Pagination className="text-right">
                  {[...Array(Math.ceil(totalRecords / recordsPerPage)).keys()].map((num) => (
                    <Pagination.Item key={num + 1} active={num + 1 === currentPage} onClick={() => setCurrentPage(num + 1)}>
                      {num + 1}
                    </Pagination.Item>
                  ))}
                </Pagination>
              </div>
            </div>
          </div>
        </div>

        {/* Invoice Payment Modal */}
        <Modal
          show={showPaymentModal}
          onHide={() => handlePaymentClose()}
          centered
          backdrop="static"
          scrollable

          dialogClassName="fullscreen-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>Manage Invoice Payments</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <InvoicePayments
              invoice_id={paymentsInvoiceId}
              onClose={() => handlePaymentClose()}
              currentUser={currentUser}
              invoiceStatus={invoiceStatus}
              selectedInvoice={selectedInvoice}
              invoiceCurrency={invoiceCurrency}
            />
          </Modal.Body>
        </Modal>
        {/* Invoice History Modal */}
        <Modal
          show={showInvoiceHistoryModal}
          onHide={() => handleInvoiceHistoryModalClose()}
          size="xl"
          centered
          backdrop="static"
          scrollable
        >
          <Modal.Header closeButton>
            <Modal.Title>Invoice History</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <InvoiceHistory
              invoice_id={paymentsInvoiceId}
              invoiceStatus={invoiceStatus}
            />
          </Modal.Body>
        </Modal>
      </div >
    </>
  );
};

export default Invoice;
